// source: api/device.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var device_proto_pb = require('../device_proto_pb.js');
goog.object.extend(proto, device_proto_pb);
var device_record_proto_pb = require('../device_record_proto_pb.js');
goog.object.extend(proto, device_record_proto_pb);
var subscription_proto_pb = require('../subscription_proto_pb.js');
goog.object.extend(proto, subscription_proto_pb);
var iridium_account_proto_pb = require('../iridium_account_proto_pb.js');
goog.object.extend(proto, iridium_account_proto_pb);
var timestamp_proto_pb = require('../timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
goog.exportSymbol('proto.somewear.api.v1.ActivateDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.AssignDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.AssignDeviceResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.BatchActivateDevicesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.BatchActivationChangeResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.BatchDisableDevicesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.BatchSuspendDevicesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CheckDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CheckDeviceResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeviceActivationStateType', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeviceEventStreamRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.DevicePlanResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.DevicePlanResponseList', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeviceUsageEventResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeviceUsageEventResponse.EventType', null, global);
goog.exportSymbol('proto.somewear.api.v1.DisableDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetActiveDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetDeviceUsageResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetDevicesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetDevicesSummaryRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetIdentityDevicesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.SuspendDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.UnassignDeviceRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.UnassignDeviceResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.UnregisterDeviceRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DeviceEventStreamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DeviceEventStreamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DeviceEventStreamRequest.displayName = 'proto.somewear.api.v1.DeviceEventStreamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetActiveDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetActiveDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetActiveDeviceRequest.displayName = 'proto.somewear.api.v1.GetActiveDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UnregisterDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UnregisterDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UnregisterDeviceRequest.displayName = 'proto.somewear.api.v1.UnregisterDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetIdentityDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetIdentityDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetIdentityDevicesRequest.displayName = 'proto.somewear.api.v1.GetIdentityDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetDevicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetDevicesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetDevicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetDevicesResponse.displayName = 'proto.somewear.api.v1.GetDevicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetDeviceUsageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetDeviceUsageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetDeviceUsageResponse.displayName = 'proto.somewear.api.v1.GetDeviceUsageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DeviceUsageEventResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DeviceUsageEventResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DeviceUsageEventResponse.displayName = 'proto.somewear.api.v1.DeviceUsageEventResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DevicePlanResponseList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.DevicePlanResponseList.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.DevicePlanResponseList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DevicePlanResponseList.displayName = 'proto.somewear.api.v1.DevicePlanResponseList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DevicePlanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DevicePlanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DevicePlanResponse.displayName = 'proto.somewear.api.v1.DevicePlanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetDevicesSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetDevicesSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetDevicesSummaryRequest.displayName = 'proto.somewear.api.v1.GetDevicesSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.AssignDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.AssignDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.AssignDeviceRequest.displayName = 'proto.somewear.api.v1.AssignDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.AssignDeviceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.AssignDeviceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.AssignDeviceResponse.displayName = 'proto.somewear.api.v1.AssignDeviceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UnassignDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UnassignDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UnassignDeviceRequest.displayName = 'proto.somewear.api.v1.UnassignDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.UnassignDeviceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.UnassignDeviceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.UnassignDeviceResponse.displayName = 'proto.somewear.api.v1.UnassignDeviceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.BatchDisableDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.BatchDisableDevicesRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.BatchDisableDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.BatchDisableDevicesRequest.displayName = 'proto.somewear.api.v1.BatchDisableDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DisableDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DisableDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DisableDeviceRequest.displayName = 'proto.somewear.api.v1.DisableDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.BatchSuspendDevicesRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.BatchSuspendDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.BatchSuspendDevicesRequest.displayName = 'proto.somewear.api.v1.BatchSuspendDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.SuspendDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.SuspendDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.SuspendDeviceRequest.displayName = 'proto.somewear.api.v1.SuspendDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.BatchActivateDevicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.BatchActivateDevicesRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.BatchActivateDevicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.BatchActivateDevicesRequest.displayName = 'proto.somewear.api.v1.BatchActivateDevicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ActivateDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ActivateDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ActivateDeviceRequest.displayName = 'proto.somewear.api.v1.ActivateDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.BatchActivationChangeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.BatchActivationChangeResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.BatchActivationChangeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.BatchActivationChangeResponse.displayName = 'proto.somewear.api.v1.BatchActivationChangeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CheckDeviceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CheckDeviceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CheckDeviceRequest.displayName = 'proto.somewear.api.v1.CheckDeviceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CheckDeviceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CheckDeviceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CheckDeviceResponse.displayName = 'proto.somewear.api.v1.CheckDeviceResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DeviceEventStreamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DeviceEventStreamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DeviceEventStreamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeviceEventStreamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DeviceEventStreamRequest}
 */
proto.somewear.api.v1.DeviceEventStreamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DeviceEventStreamRequest;
  return proto.somewear.api.v1.DeviceEventStreamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DeviceEventStreamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DeviceEventStreamRequest}
 */
proto.somewear.api.v1.DeviceEventStreamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DeviceEventStreamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DeviceEventStreamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DeviceEventStreamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeviceEventStreamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetActiveDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetActiveDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetActiveDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetActiveDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetActiveDeviceRequest}
 */
proto.somewear.api.v1.GetActiveDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetActiveDeviceRequest;
  return proto.somewear.api.v1.GetActiveDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetActiveDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetActiveDeviceRequest}
 */
proto.somewear.api.v1.GetActiveDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetActiveDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetActiveDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetActiveDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetActiveDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UnregisterDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UnregisterDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UnregisterDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UnregisterDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UnregisterDeviceRequest}
 */
proto.somewear.api.v1.UnregisterDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UnregisterDeviceRequest;
  return proto.somewear.api.v1.UnregisterDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UnregisterDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UnregisterDeviceRequest}
 */
proto.somewear.api.v1.UnregisterDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UnregisterDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UnregisterDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UnregisterDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UnregisterDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetIdentityDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetIdentityDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetIdentityDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetIdentityDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetIdentityDevicesRequest}
 */
proto.somewear.api.v1.GetIdentityDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetIdentityDevicesRequest;
  return proto.somewear.api.v1.GetIdentityDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetIdentityDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetIdentityDevicesRequest}
 */
proto.somewear.api.v1.GetIdentityDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetIdentityDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetIdentityDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetIdentityDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetIdentityDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetDevicesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetDevicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetDevicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetDevicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDevicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceList: jspb.Message.toObjectList(msg.getDeviceList(),
    device_record_proto_pb.DeviceRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetDevicesResponse}
 */
proto.somewear.api.v1.GetDevicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetDevicesResponse;
  return proto.somewear.api.v1.GetDevicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetDevicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetDevicesResponse}
 */
proto.somewear.api.v1.GetDevicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new device_record_proto_pb.DeviceRecord;
      reader.readMessage(value,device_record_proto_pb.DeviceRecord.deserializeBinaryFromReader);
      msg.addDevice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetDevicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetDevicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetDevicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDevicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      device_record_proto_pb.DeviceRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceRecord device = 1;
 * @return {!Array<!proto.DeviceRecord>}
 */
proto.somewear.api.v1.GetDevicesResponse.prototype.getDeviceList = function() {
  return /** @type{!Array<!proto.DeviceRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, device_record_proto_pb.DeviceRecord, 1));
};


/**
 * @param {!Array<!proto.DeviceRecord>} value
 * @return {!proto.somewear.api.v1.GetDevicesResponse} returns this
*/
proto.somewear.api.v1.GetDevicesResponse.prototype.setDeviceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.DeviceRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.DeviceRecord}
 */
proto.somewear.api.v1.GetDevicesResponse.prototype.addDevice = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.DeviceRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetDevicesResponse} returns this
 */
proto.somewear.api.v1.GetDevicesResponse.prototype.clearDeviceList = function() {
  return this.setDeviceList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetDeviceUsageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetDeviceUsageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDeviceUsageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
bytesUsed: jspb.Message.getFieldWithDefault(msg, 2, 0),
bytesIncluded: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetDeviceUsageResponse}
 */
proto.somewear.api.v1.GetDeviceUsageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetDeviceUsageResponse;
  return proto.somewear.api.v1.GetDeviceUsageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetDeviceUsageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetDeviceUsageResponse}
 */
proto.somewear.api.v1.GetDeviceUsageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBytesUsed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBytesIncluded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetDeviceUsageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetDeviceUsageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDeviceUsageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBytesUsed();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBytesIncluded();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.GetDeviceUsageResponse} returns this
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 bytes_used = 2;
 * @return {number}
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.getBytesUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.somewear.api.v1.GetDeviceUsageResponse} returns this
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.setBytesUsed = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 bytes_included = 3;
 * @return {number}
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.getBytesIncluded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.somewear.api.v1.GetDeviceUsageResponse} returns this
 */
proto.somewear.api.v1.GetDeviceUsageResponse.prototype.setBytesIncluded = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DeviceUsageEventResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DeviceUsageEventResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeviceUsageEventResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
serial: jspb.Message.getFieldWithDefault(msg, 2, ""),
timestamp: (f = msg.getTimestamp()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
eventType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DeviceUsageEventResponse;
  return proto.somewear.api.v1.DeviceUsageEventResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DeviceUsageEventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 3:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {!proto.somewear.api.v1.DeviceUsageEventResponse.EventType} */ (reader.readEnum());
      msg.setEventType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DeviceUsageEventResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DeviceUsageEventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeviceUsageEventResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEventType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.EventType = {
  UNKNOWN: 0,
  HIGH_USAGE: 1,
  EXCEEDED_USAGE_LIMIT: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse} returns this
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string serial = 2;
 * @return {string}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse} returns this
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Timestamp timestamp = 3;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.getTimestamp = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 3));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse} returns this
*/
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.setTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse} returns this
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EventType event_type = 4;
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse.EventType}
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.getEventType = function() {
  return /** @type {!proto.somewear.api.v1.DeviceUsageEventResponse.EventType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.somewear.api.v1.DeviceUsageEventResponse.EventType} value
 * @return {!proto.somewear.api.v1.DeviceUsageEventResponse} returns this
 */
proto.somewear.api.v1.DeviceUsageEventResponse.prototype.setEventType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.DevicePlanResponseList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DevicePlanResponseList.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DevicePlanResponseList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DevicePlanResponseList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DevicePlanResponseList.toObject = function(includeInstance, msg) {
  var f, obj = {
devicePlansList: jspb.Message.toObjectList(msg.getDevicePlansList(),
    proto.somewear.api.v1.DevicePlanResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DevicePlanResponseList}
 */
proto.somewear.api.v1.DevicePlanResponseList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DevicePlanResponseList;
  return proto.somewear.api.v1.DevicePlanResponseList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DevicePlanResponseList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DevicePlanResponseList}
 */
proto.somewear.api.v1.DevicePlanResponseList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.DevicePlanResponse;
      reader.readMessage(value,proto.somewear.api.v1.DevicePlanResponse.deserializeBinaryFromReader);
      msg.addDevicePlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DevicePlanResponseList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DevicePlanResponseList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DevicePlanResponseList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DevicePlanResponseList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicePlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.somewear.api.v1.DevicePlanResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DevicePlanResponse device_plans = 1;
 * @return {!Array<!proto.somewear.api.v1.DevicePlanResponse>}
 */
proto.somewear.api.v1.DevicePlanResponseList.prototype.getDevicePlansList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.DevicePlanResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.DevicePlanResponse, 1));
};


/**
 * @param {!Array<!proto.somewear.api.v1.DevicePlanResponse>} value
 * @return {!proto.somewear.api.v1.DevicePlanResponseList} returns this
*/
proto.somewear.api.v1.DevicePlanResponseList.prototype.setDevicePlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.somewear.api.v1.DevicePlanResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.DevicePlanResponse}
 */
proto.somewear.api.v1.DevicePlanResponseList.prototype.addDevicePlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.somewear.api.v1.DevicePlanResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.DevicePlanResponseList} returns this
 */
proto.somewear.api.v1.DevicePlanResponseList.prototype.clearDevicePlansList = function() {
  return this.setDevicePlansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DevicePlanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DevicePlanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DevicePlanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionPlan: jspb.Message.getFieldWithDefault(msg, 2, 0),
sbdPlan: jspb.Message.getFieldWithDefault(msg, 3, ""),
subscriptionStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
iridiumStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
iridiumAccountCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
subscriptionCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
activationState: jspb.Message.getFieldWithDefault(msg, 8, 0),
billingPeriodEnding: (f = msg.getBillingPeriodEnding()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
sbdLastModified: (f = msg.getSbdLastModified()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DevicePlanResponse}
 */
proto.somewear.api.v1.DevicePlanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DevicePlanResponse;
  return proto.somewear.api.v1.DevicePlanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DevicePlanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DevicePlanResponse}
 */
proto.somewear.api.v1.DevicePlanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 2:
      var value = /** @type {!proto.SubscriptionRequest.Plan} */ (reader.readEnum());
      msg.setSubscriptionPlan(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbdPlan(value);
      break;
    case 4:
      var value = /** @type {!proto.SubscriptionRecord.Status} */ (reader.readEnum());
      msg.setSubscriptionStatus(value);
      break;
    case 5:
      var value = /** @type {!proto.IridiumAccount.Status} */ (reader.readEnum());
      msg.setIridiumStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIridiumAccountCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionCode(value);
      break;
    case 8:
      var value = /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (reader.readEnum());
      msg.setActivationState(value);
      break;
    case 9:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBillingPeriodEnding(value);
      break;
    case 10:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSbdLastModified(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DevicePlanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DevicePlanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DevicePlanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionPlan();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSbdPlan();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubscriptionStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getIridiumStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIridiumAccountCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSubscriptionCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getActivationState();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getBillingPeriodEnding();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSbdLastModified();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SubscriptionRequest.Plan subscription_plan = 2;
 * @return {!proto.SubscriptionRequest.Plan}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getSubscriptionPlan = function() {
  return /** @type {!proto.SubscriptionRequest.Plan} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.SubscriptionRequest.Plan} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setSubscriptionPlan = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string sbd_plan = 3;
 * @return {string}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getSbdPlan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setSbdPlan = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SubscriptionRecord.Status subscription_status = 4;
 * @return {!proto.SubscriptionRecord.Status}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getSubscriptionStatus = function() {
  return /** @type {!proto.SubscriptionRecord.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SubscriptionRecord.Status} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setSubscriptionStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional IridiumAccount.Status iridium_status = 5;
 * @return {!proto.IridiumAccount.Status}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getIridiumStatus = function() {
  return /** @type {!proto.IridiumAccount.Status} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.IridiumAccount.Status} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setIridiumStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string iridium_account_code = 6;
 * @return {string}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getIridiumAccountCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setIridiumAccountCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string subscription_code = 7;
 * @return {string}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getSubscriptionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setSubscriptionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional DeviceActivationStateType activation_state = 8;
 * @return {!proto.somewear.api.v1.DeviceActivationStateType}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getActivationState = function() {
  return /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.somewear.api.v1.DeviceActivationStateType} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.setActivationState = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional Timestamp billing_period_ending = 9;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getBillingPeriodEnding = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 9));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
*/
proto.somewear.api.v1.DevicePlanResponse.prototype.setBillingPeriodEnding = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.clearBillingPeriodEnding = function() {
  return this.setBillingPeriodEnding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.hasBillingPeriodEnding = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Timestamp sbd_last_modified = 10;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.getSbdLastModified = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 10));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
*/
proto.somewear.api.v1.DevicePlanResponse.prototype.setSbdLastModified = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.DevicePlanResponse} returns this
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.clearSbdLastModified = function() {
  return this.setSbdLastModified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.DevicePlanResponse.prototype.hasSbdLastModified = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetDevicesSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetDevicesSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetDevicesSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDevicesSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetDevicesSummaryRequest}
 */
proto.somewear.api.v1.GetDevicesSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetDevicesSummaryRequest;
  return proto.somewear.api.v1.GetDevicesSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetDevicesSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetDevicesSummaryRequest}
 */
proto.somewear.api.v1.GetDevicesSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetDevicesSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetDevicesSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetDevicesSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetDevicesSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.AssignDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.AssignDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.AssignDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
targetUserId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
targetIdentityId: jspb.Message.getFieldWithDefault(msg, 3, ""),
targetWorkspaceId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.AssignDeviceRequest}
 */
proto.somewear.api.v1.AssignDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.AssignDeviceRequest;
  return proto.somewear.api.v1.AssignDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.AssignDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.AssignDeviceRequest}
 */
proto.somewear.api.v1.AssignDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetIdentityId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.AssignDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.AssignDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.AssignDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTargetIdentityId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTargetWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.AssignDeviceRequest} returns this
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target_user_id = 2;
 * @return {string}
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.getTargetUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.AssignDeviceRequest} returns this
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.setTargetUserId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.somewear.api.v1.AssignDeviceRequest} returns this
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.clearTargetUserId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.hasTargetUserId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string target_identity_id = 3;
 * @return {string}
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.getTargetIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.AssignDeviceRequest} returns this
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.setTargetIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string target_workspace_id = 4;
 * @return {string}
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.getTargetWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.AssignDeviceRequest} returns this
 */
proto.somewear.api.v1.AssignDeviceRequest.prototype.setTargetWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.AssignDeviceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.AssignDeviceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.AssignDeviceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.AssignDeviceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
device: (f = msg.getDevice()) && device_record_proto_pb.DeviceRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.AssignDeviceResponse}
 */
proto.somewear.api.v1.AssignDeviceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.AssignDeviceResponse;
  return proto.somewear.api.v1.AssignDeviceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.AssignDeviceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.AssignDeviceResponse}
 */
proto.somewear.api.v1.AssignDeviceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new device_record_proto_pb.DeviceRecord;
      reader.readMessage(value,device_record_proto_pb.DeviceRecord.deserializeBinaryFromReader);
      msg.setDevice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.AssignDeviceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.AssignDeviceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.AssignDeviceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.AssignDeviceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      device_record_proto_pb.DeviceRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceRecord device = 1;
 * @return {?proto.DeviceRecord}
 */
proto.somewear.api.v1.AssignDeviceResponse.prototype.getDevice = function() {
  return /** @type{?proto.DeviceRecord} */ (
    jspb.Message.getWrapperField(this, device_record_proto_pb.DeviceRecord, 1));
};


/**
 * @param {?proto.DeviceRecord|undefined} value
 * @return {!proto.somewear.api.v1.AssignDeviceResponse} returns this
*/
proto.somewear.api.v1.AssignDeviceResponse.prototype.setDevice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.AssignDeviceResponse} returns this
 */
proto.somewear.api.v1.AssignDeviceResponse.prototype.clearDevice = function() {
  return this.setDevice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.AssignDeviceResponse.prototype.hasDevice = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UnassignDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UnassignDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UnassignDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UnassignDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UnassignDeviceRequest}
 */
proto.somewear.api.v1.UnassignDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UnassignDeviceRequest;
  return proto.somewear.api.v1.UnassignDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UnassignDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UnassignDeviceRequest}
 */
proto.somewear.api.v1.UnassignDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UnassignDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UnassignDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UnassignDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UnassignDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.UnassignDeviceRequest.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.UnassignDeviceRequest} returns this
 */
proto.somewear.api.v1.UnassignDeviceRequest.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.UnassignDeviceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.UnassignDeviceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.UnassignDeviceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UnassignDeviceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
device: (f = msg.getDevice()) && device_record_proto_pb.DeviceRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.UnassignDeviceResponse}
 */
proto.somewear.api.v1.UnassignDeviceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.UnassignDeviceResponse;
  return proto.somewear.api.v1.UnassignDeviceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.UnassignDeviceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.UnassignDeviceResponse}
 */
proto.somewear.api.v1.UnassignDeviceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new device_record_proto_pb.DeviceRecord;
      reader.readMessage(value,device_record_proto_pb.DeviceRecord.deserializeBinaryFromReader);
      msg.setDevice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.UnassignDeviceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.UnassignDeviceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.UnassignDeviceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.UnassignDeviceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      device_record_proto_pb.DeviceRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceRecord device = 1;
 * @return {?proto.DeviceRecord}
 */
proto.somewear.api.v1.UnassignDeviceResponse.prototype.getDevice = function() {
  return /** @type{?proto.DeviceRecord} */ (
    jspb.Message.getWrapperField(this, device_record_proto_pb.DeviceRecord, 1));
};


/**
 * @param {?proto.DeviceRecord|undefined} value
 * @return {!proto.somewear.api.v1.UnassignDeviceResponse} returns this
*/
proto.somewear.api.v1.UnassignDeviceResponse.prototype.setDevice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.UnassignDeviceResponse} returns this
 */
proto.somewear.api.v1.UnassignDeviceResponse.prototype.clearDevice = function() {
  return this.setDevice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.UnassignDeviceResponse.prototype.hasDevice = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.BatchDisableDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.BatchDisableDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.somewear.api.v1.DisableDeviceRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.BatchDisableDevicesRequest}
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.BatchDisableDevicesRequest;
  return proto.somewear.api.v1.BatchDisableDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.BatchDisableDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.BatchDisableDevicesRequest}
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.DisableDeviceRequest;
      reader.readMessage(value,proto.somewear.api.v1.DisableDeviceRequest.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.BatchDisableDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.BatchDisableDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.somewear.api.v1.DisableDeviceRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DisableDeviceRequest requests = 1;
 * @return {!Array<!proto.somewear.api.v1.DisableDeviceRequest>}
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.DisableDeviceRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.DisableDeviceRequest, 1));
};


/**
 * @param {!Array<!proto.somewear.api.v1.DisableDeviceRequest>} value
 * @return {!proto.somewear.api.v1.BatchDisableDevicesRequest} returns this
*/
proto.somewear.api.v1.BatchDisableDevicesRequest.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.somewear.api.v1.DisableDeviceRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.DisableDeviceRequest}
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.somewear.api.v1.DisableDeviceRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.BatchDisableDevicesRequest} returns this
 */
proto.somewear.api.v1.BatchDisableDevicesRequest.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DisableDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DisableDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DisableDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DisableDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
currentState: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DisableDeviceRequest}
 */
proto.somewear.api.v1.DisableDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DisableDeviceRequest;
  return proto.somewear.api.v1.DisableDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DisableDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DisableDeviceRequest}
 */
proto.somewear.api.v1.DisableDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 2:
      var value = /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (reader.readEnum());
      msg.setCurrentState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DisableDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DisableDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DisableDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DisableDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrentState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.DisableDeviceRequest.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DisableDeviceRequest} returns this
 */
proto.somewear.api.v1.DisableDeviceRequest.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceActivationStateType current_state = 2;
 * @return {!proto.somewear.api.v1.DeviceActivationStateType}
 */
proto.somewear.api.v1.DisableDeviceRequest.prototype.getCurrentState = function() {
  return /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.somewear.api.v1.DeviceActivationStateType} value
 * @return {!proto.somewear.api.v1.DisableDeviceRequest} returns this
 */
proto.somewear.api.v1.DisableDeviceRequest.prototype.setCurrentState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.BatchSuspendDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.BatchSuspendDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.somewear.api.v1.SuspendDeviceRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.BatchSuspendDevicesRequest}
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.BatchSuspendDevicesRequest;
  return proto.somewear.api.v1.BatchSuspendDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.BatchSuspendDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.BatchSuspendDevicesRequest}
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.SuspendDeviceRequest;
      reader.readMessage(value,proto.somewear.api.v1.SuspendDeviceRequest.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.BatchSuspendDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.BatchSuspendDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.somewear.api.v1.SuspendDeviceRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SuspendDeviceRequest requests = 1;
 * @return {!Array<!proto.somewear.api.v1.SuspendDeviceRequest>}
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.SuspendDeviceRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.SuspendDeviceRequest, 1));
};


/**
 * @param {!Array<!proto.somewear.api.v1.SuspendDeviceRequest>} value
 * @return {!proto.somewear.api.v1.BatchSuspendDevicesRequest} returns this
*/
proto.somewear.api.v1.BatchSuspendDevicesRequest.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.somewear.api.v1.SuspendDeviceRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.SuspendDeviceRequest}
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.somewear.api.v1.SuspendDeviceRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.BatchSuspendDevicesRequest} returns this
 */
proto.somewear.api.v1.BatchSuspendDevicesRequest.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.SuspendDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.SuspendDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.SuspendDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.SuspendDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
currentState: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.SuspendDeviceRequest}
 */
proto.somewear.api.v1.SuspendDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.SuspendDeviceRequest;
  return proto.somewear.api.v1.SuspendDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.SuspendDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.SuspendDeviceRequest}
 */
proto.somewear.api.v1.SuspendDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 2:
      var value = /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (reader.readEnum());
      msg.setCurrentState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.SuspendDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.SuspendDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.SuspendDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.SuspendDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrentState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.SuspendDeviceRequest.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.SuspendDeviceRequest} returns this
 */
proto.somewear.api.v1.SuspendDeviceRequest.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceActivationStateType current_state = 2;
 * @return {!proto.somewear.api.v1.DeviceActivationStateType}
 */
proto.somewear.api.v1.SuspendDeviceRequest.prototype.getCurrentState = function() {
  return /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.somewear.api.v1.DeviceActivationStateType} value
 * @return {!proto.somewear.api.v1.SuspendDeviceRequest} returns this
 */
proto.somewear.api.v1.SuspendDeviceRequest.prototype.setCurrentState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.BatchActivateDevicesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.BatchActivateDevicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
requestsList: jspb.Message.toObjectList(msg.getRequestsList(),
    proto.somewear.api.v1.ActivateDeviceRequest.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.BatchActivateDevicesRequest}
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.BatchActivateDevicesRequest;
  return proto.somewear.api.v1.BatchActivateDevicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.BatchActivateDevicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.BatchActivateDevicesRequest}
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.somewear.api.v1.ActivateDeviceRequest;
      reader.readMessage(value,proto.somewear.api.v1.ActivateDeviceRequest.deserializeBinaryFromReader);
      msg.addRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.BatchActivateDevicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.BatchActivateDevicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.somewear.api.v1.ActivateDeviceRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivateDeviceRequest requests = 1;
 * @return {!Array<!proto.somewear.api.v1.ActivateDeviceRequest>}
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.prototype.getRequestsList = function() {
  return /** @type{!Array<!proto.somewear.api.v1.ActivateDeviceRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.somewear.api.v1.ActivateDeviceRequest, 1));
};


/**
 * @param {!Array<!proto.somewear.api.v1.ActivateDeviceRequest>} value
 * @return {!proto.somewear.api.v1.BatchActivateDevicesRequest} returns this
*/
proto.somewear.api.v1.BatchActivateDevicesRequest.prototype.setRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.somewear.api.v1.ActivateDeviceRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.ActivateDeviceRequest}
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.prototype.addRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.somewear.api.v1.ActivateDeviceRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.BatchActivateDevicesRequest} returns this
 */
proto.somewear.api.v1.BatchActivateDevicesRequest.prototype.clearRequestsList = function() {
  return this.setRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ActivateDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ActivateDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ActivateDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ActivateDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
serial: jspb.Message.getFieldWithDefault(msg, 1, ""),
currentState: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ActivateDeviceRequest}
 */
proto.somewear.api.v1.ActivateDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ActivateDeviceRequest;
  return proto.somewear.api.v1.ActivateDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ActivateDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ActivateDeviceRequest}
 */
proto.somewear.api.v1.ActivateDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerial(value);
      break;
    case 2:
      var value = /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (reader.readEnum());
      msg.setCurrentState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ActivateDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ActivateDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ActivateDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ActivateDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrentState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string serial = 1;
 * @return {string}
 */
proto.somewear.api.v1.ActivateDeviceRequest.prototype.getSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.ActivateDeviceRequest} returns this
 */
proto.somewear.api.v1.ActivateDeviceRequest.prototype.setSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeviceActivationStateType current_state = 2;
 * @return {!proto.somewear.api.v1.DeviceActivationStateType}
 */
proto.somewear.api.v1.ActivateDeviceRequest.prototype.getCurrentState = function() {
  return /** @type {!proto.somewear.api.v1.DeviceActivationStateType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.somewear.api.v1.DeviceActivationStateType} value
 * @return {!proto.somewear.api.v1.ActivateDeviceRequest} returns this
 */
proto.somewear.api.v1.ActivateDeviceRequest.prototype.setCurrentState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.BatchActivationChangeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.BatchActivationChangeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.BatchActivationChangeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.BatchActivationChangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchActivationChangeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
serialsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.BatchActivationChangeResponse}
 */
proto.somewear.api.v1.BatchActivationChangeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.BatchActivationChangeResponse;
  return proto.somewear.api.v1.BatchActivationChangeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.BatchActivationChangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.BatchActivationChangeResponse}
 */
proto.somewear.api.v1.BatchActivationChangeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSerials(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.BatchActivationChangeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.BatchActivationChangeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.BatchActivationChangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.BatchActivationChangeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSerialsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string serials = 1;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.BatchActivationChangeResponse.prototype.getSerialsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.BatchActivationChangeResponse} returns this
 */
proto.somewear.api.v1.BatchActivationChangeResponse.prototype.setSerialsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.BatchActivationChangeResponse} returns this
 */
proto.somewear.api.v1.BatchActivationChangeResponse.prototype.addSerials = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.BatchActivationChangeResponse} returns this
 */
proto.somewear.api.v1.BatchActivationChangeResponse.prototype.clearSerialsList = function() {
  return this.setSerialsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CheckDeviceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CheckDeviceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CheckDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CheckDeviceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
device: (f = msg.getDevice()) && device_record_proto_pb.DeviceRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CheckDeviceRequest}
 */
proto.somewear.api.v1.CheckDeviceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CheckDeviceRequest;
  return proto.somewear.api.v1.CheckDeviceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CheckDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CheckDeviceRequest}
 */
proto.somewear.api.v1.CheckDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new device_record_proto_pb.DeviceRecord;
      reader.readMessage(value,device_record_proto_pb.DeviceRecord.deserializeBinaryFromReader);
      msg.setDevice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CheckDeviceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CheckDeviceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CheckDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CheckDeviceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      device_record_proto_pb.DeviceRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceRecord device = 1;
 * @return {?proto.DeviceRecord}
 */
proto.somewear.api.v1.CheckDeviceRequest.prototype.getDevice = function() {
  return /** @type{?proto.DeviceRecord} */ (
    jspb.Message.getWrapperField(this, device_record_proto_pb.DeviceRecord, 1));
};


/**
 * @param {?proto.DeviceRecord|undefined} value
 * @return {!proto.somewear.api.v1.CheckDeviceRequest} returns this
*/
proto.somewear.api.v1.CheckDeviceRequest.prototype.setDevice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CheckDeviceRequest} returns this
 */
proto.somewear.api.v1.CheckDeviceRequest.prototype.clearDevice = function() {
  return this.setDevice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CheckDeviceRequest.prototype.hasDevice = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CheckDeviceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CheckDeviceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CheckDeviceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CheckDeviceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
device: (f = msg.getDevice()) && device_record_proto_pb.DeviceRecord.toObject(includeInstance, f),
accountStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CheckDeviceResponse}
 */
proto.somewear.api.v1.CheckDeviceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CheckDeviceResponse;
  return proto.somewear.api.v1.CheckDeviceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CheckDeviceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CheckDeviceResponse}
 */
proto.somewear.api.v1.CheckDeviceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new device_record_proto_pb.DeviceRecord;
      reader.readMessage(value,device_record_proto_pb.DeviceRecord.deserializeBinaryFromReader);
      msg.setDevice(value);
      break;
    case 2:
      var value = /** @type {!proto.IridiumAccount.Status} */ (reader.readEnum());
      msg.setAccountStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CheckDeviceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CheckDeviceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CheckDeviceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CheckDeviceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      device_record_proto_pb.DeviceRecord.serializeBinaryToWriter
    );
  }
  f = message.getAccountStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional DeviceRecord device = 1;
 * @return {?proto.DeviceRecord}
 */
proto.somewear.api.v1.CheckDeviceResponse.prototype.getDevice = function() {
  return /** @type{?proto.DeviceRecord} */ (
    jspb.Message.getWrapperField(this, device_record_proto_pb.DeviceRecord, 1));
};


/**
 * @param {?proto.DeviceRecord|undefined} value
 * @return {!proto.somewear.api.v1.CheckDeviceResponse} returns this
*/
proto.somewear.api.v1.CheckDeviceResponse.prototype.setDevice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CheckDeviceResponse} returns this
 */
proto.somewear.api.v1.CheckDeviceResponse.prototype.clearDevice = function() {
  return this.setDevice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CheckDeviceResponse.prototype.hasDevice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional IridiumAccount.Status account_status = 2;
 * @return {!proto.IridiumAccount.Status}
 */
proto.somewear.api.v1.CheckDeviceResponse.prototype.getAccountStatus = function() {
  return /** @type {!proto.IridiumAccount.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.IridiumAccount.Status} value
 * @return {!proto.somewear.api.v1.CheckDeviceResponse} returns this
 */
proto.somewear.api.v1.CheckDeviceResponse.prototype.setAccountStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.somewear.api.v1.DeviceActivationStateType = {
  STATUS_NONE: 0,
  STATUS_INACTIVE: 1,
  STATUS_ACTIVE: 3,
  STATUS_DISABLED: 4,
  STATUS_SUSPENDING: 5,
  STATUS_SUSPENDED: 6,
  STATUS_ERROR: 7
};

goog.object.extend(exports, proto.somewear.api.v1);
